import { Button, Card, Col, Row } from "antd";
import { BiExit, BiSave } from "react-icons/bi";
import { MdOutlinePhonelinkLock } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import { useState, useEffect } from "react";
import {
  fetchCustomDeviceToken,
  getSignedURL,
  triggerAction,
} from "../services/fetchApis";
import { ActionCommands, CARDS, PROJECTS } from "../constants/Actions";
import { LOG_IN_TYPE } from "../constants/auth";
import UserService from "../utils/userService";

/// to avoid to show it for any
export const SHOW_REMOTE_ACTIONS_TO_ROLES_IDS = [1];

const RemoteActionsComponent = ({ data }) => {
  const [deviceToken, setDeviceToken] = useState("");
  const [triggeredId, setTriggeredAction] = useState("Trigger");
  const [triggerResult, setTriggerResult] = useState({
    result: {
      type: "",
      msg: "Waiting to be triggered",
    },
    triggeredFrom: "",
  });

  const CardStyle = {
    border: "1px solid #e8e8e8",
    margin: "2px",
  };

  const titleStyle = {
    borderBottom: "1px solid #e8e8e8",
    padding: ".5px",
  };

  const contentStyle = {
    padding: "0.5px",
  };

  const onClickTrigger = async (
    card,
    mobile,
    triggerName,
    project,
    type = ""
  ) => {
    const token = card?.project === PROJECTS.TA ? data?.fcmToken : deviceToken;
    let result = null;
    let resetCTATime = 10000;
    if (token?.length !== 0) {
      setTriggeredAction(card.id);
      switch (card?.title) {
        case ActionCommands.CAPTURE_TA_LOG:
          const signedUrlObject = await getSignedURL(
            `${data?.mdmDeviceId ?? "TEST_FOLDER"}`,
            "talog.txt",
            "text/plain",
            `LOGS/${data?.mdmDeviceId}/TA_LOGS`
          );

          const user = UserService.getUserData();
          const loginType = UserService.getLogInType();
          let userId = null;
          if (loginType === LOG_IN_TYPE.nucleus) {
            userId = user?.id;
          } else {
            userId = user?.email;
          }
          if (signedUrlObject && signedUrlObject.data) {
            const actionBody = {
              actions: {
                triggeredBy: userId,
                signedUrl: signedUrlObject.data,
                cdnPath: signedUrlObject.key,
                cdnUrl: process.env.REACT_APP_AWS_URL + signedUrlObject.key,
              },
            };
            result = await triggerAction(
              token,
              mobile,
              triggerName,
              project,
              actionBody
            );
          } else {
            result = { status: "FALSE" };
          }
          break;
        default:
          result = await triggerAction(token, mobile, triggerName, project);
          break;
      }
      try {
        if (
          result === null ||
          result === undefined ||
          result?.status === "FALSE"
        ) {
          setTriggerResult((prevState) => ({
            ...prevState,
            triggeredFrom: type,
            result: {
              type: "error",
              msg: "Failed to trigger",
            },
          }));
        } else {
          setTriggerResult((prevState) => ({
            ...prevState,
            triggeredFrom: type,
            result: {
              type: "success",
              msg: "triggered successfully",
            },
          }));
          setTimeout(() => {
            setTriggeredAction(null);
          }, resetCTATime);
          return;
        }
      } catch (err) {
        console.log("trigger error", err);
        setTriggerResult((prevState) => ({
          ...prevState,
          triggeredFrom: type,
          result: {
            type: "error",
            msg: "Failed to trigger",
          },
        }));
      }
      setTriggeredAction(null);
    }
  };

  useEffect(() => {
    tpsDeviceToken().then((devToken) => {
      setDeviceToken(devToken);
    });
  }, []);

  const tpsDeviceToken = async () => {
    let response = "";
    if (data?.mdmDeviceId) {
      response = await fetchCustomDeviceToken(data.mdmDeviceId);
      if (response && response.data && response.data.custom1) {
        return response.data.custom1;
      }
    }
    return null;
  };

  const actionIconMap = {
    LOCK_DEVICE: <MdOutlinePhonelinkLock />,
    EXIT_LAUNCHER: <BiExit />,
    UNLOCK_DEVICE: <MdOutlinePhonelinkLock />,
    CAPTURE_TA_LOG: <BiSave />,
  };

  return (
    <>
      {CARDS.map((card, index) => {
        let canTrigger = false;
        if (
          card?.project === PROJECTS.TA &&
          data?.fcmToken &&
          data?.fcmToken.length > 1
        ) {
          canTrigger = true;
        } else if (
          card?.project === PROJECTS.TPS &&
          deviceToken &&
          deviceToken.length > 1
        ) {
          canTrigger = true;
        }

        return (
          <Card style={CardStyle} key={"ra_" + index}>
            <Row className="align-items-center">
              <Col
                sm={12}
                md={1}
                className="d-flex justify-content-center align-items-center"
              >
                <h5>{actionIconMap[card.title]}</h5>
              </Col>
              <Col
                sm={12}
                md={4}
                className="justify-content-center align-items-center"
                style={{ marginTop: "10px" }}
              >
                <div style={titleStyle}>
                  <b>{card.title}</b>
                </div>
                <div style={contentStyle}>
                  <p>{card.description}</p>
                </div>
              </Col>
              <Col
                sm={12}
                md={7}
                className="d-flex justify-content-center align-items-end ml-auto"
              >
                <Button
                  className="btn-remote_btn mr-2"
                  disabled={!canTrigger}
                  onClick={() =>
                    onClickTrigger(
                      card,
                      data?.teacherMobile,
                      card.triggerName,
                      card.project,
                      ""
                    )
                  }
                >
                  {triggeredId === card.id ? "Running..." : "Trigger"}
                </Button>
              </Col>
            </Row>
          </Card>
        );
      })}
    </>
  );
};

export default RemoteActionsComponent;
